module.exports = __webpack_public_path__ + "img/google-logo.65442351.png";